/*
 * 文件EN: quotaChange.js,
 * 文件CN: 额度调整,
 * 创建时间: Friday, 15th May 2020 5:16:26 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */
import * as Models from '@/api/T3/DHGL/quotaChange'

export default {
  namespaced: true,
  actions: {
    // 获取列表
    getList(ctx, payload) {
      return Models.getListData(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    },
    // 查询申请额度调整数据详情
    getDetails(ctx, payload) {
      return Models.fetchDetails(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    },
    // 详情 - 申请记录列表
    getDetailsList(ctx, payload) {
      return Models.fetchDetailsList(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    },
    onSubmit(ctx, payload) {
      return Models.TODO_Submit(payload).then(res => {
        return res
      })
    },
  }
}